import { MagpieConnection } from 'magpie-lib/connection';
import { tourTopic } from './tour.topic';
import { syncMessages } from './sync.messages';
import { Logger } from 'simple-logging-lib';
import { LOGGER_NAME } from '../logging/setupLogger';
const sendPartyAlive = (party, onReply) => {
  const logger = Logger.getLogger(LOGGER_NAME);
  logger.debug(`Sending partyAlive message for party ${party}`);
  const message = syncMessages.partyAlive.create({
    party
  });
  MagpieConnection.get().useTopic(tourTopic).publish(message, {
    onReply: reply => {
      const incomingParty = reply.payload.party;
      if (incomingParty !== party) {
        logger.debug(`Party ${party} received ack from party ${incomingParty}`);
        onReply === null || onReply === void 0 || onReply(incomingParty);
      }
    }
  });
};
const subscribeToPartyAlive = (party, onReceivePartyAlive) => {
  const logger = Logger.getLogger(LOGGER_NAME);
  return MagpieConnection.get().useTopic(tourTopic).on(syncMessages.partyAlive.getType(), (partyAliveMessage, api) => {
    const incomingParty = partyAliveMessage.payload.party;
    if (incomingParty !== party) {
      logger.debug(`Party ${party} received partyAlive from party ${incomingParty}`);
      onReceivePartyAlive === null || onReceivePartyAlive === void 0 || onReceivePartyAlive(incomingParty);
    }
    api.reply(syncMessages.partyAck.create({
      party
    }));
  });
};
export const partyAlive = (party, onPartyAlive) => {
  sendPartyAlive(party, onPartyAlive);
  return subscribeToPartyAlive(party, onPartyAlive);
};